<template>
    <div id="about-us-page">

        <!-- Big banner Section -->
        <div class="jumbotron jumbotron-big text-center about-us-image">
            <!--<div class="dark-layer"></div>-->
            <div class="white position-absolute top-0 row h-100 w-100 justify-content-center align-items-center text-center margin-right-left-0">
                <div class="jumbo-info">
                    <h1 class="text-uppercase font-xl white text-shadow">About us</h1>
                    <div class="row justify-content-sm-center">
                        <div class="col-12 col-md-8">
                            <p class="white">Ultimate Jet Vacations is a concierge style boutique tour operator that customizes travel itineraries and packages to 5-Star hotels & resorts.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="controllers-cont">
                <next-section-arrow></next-section-arrow>
            </div>
        </div>

        <!-- Agents Section -->
        <section v-if="showAgents" class="section-style">
            <div class="container padding-right-left-0"
                 data-aos="fade-left"
                 data-aos-offset="100"
                 data-aos-once="true"
                 data-aos-duration="500">
                <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Meet our team</h2>

                <div class="row justify-content-center mb-5">
                    <div class="col-auto">
                        <ul class="nav nav-pills mb-3 pill-tabs-custom" id="pills-tab" role="tablist">
                            <li class="nav-item col-12 col-lg-auto">
                                <a class="btn btn-light active text-uppercase btn-lg mx-sm-2 my-lg-0 my-2 w-100" id="pills-ta-tab" data-toggle="pill" href="#pills-ta" role="tab" aria-controls="pills-ta" aria-selected="true">Travel Advisors & Sales</a>
                            </li>
                            <li class="nav-item col-12 col-lg-auto">
                                <a class="btn btn-light text-uppercase btn-lg mx-sm-2 my-lg-0 my-2 w-100" id="pills-bd-tab" data-toggle="pill" href="#pills-bd" role="tab" aria-controls="pills-bd" aria-selected="false">Business Development</a>
                            </li>
                            <li class="nav-item col-12 col-lg-auto">
                                <a class="btn btn-light text-uppercase btn-lg mx-sm-2 my-lg-0 my-2 w-100" id="pills-co-tab" data-toggle="pill" href="#pills-co" role="tab" aria-controls="pills-co" aria-selected="false">Concierge</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-ta" role="tabpanel" aria-labelledby="pills-ta-tab">
                        <div class="row justify-content-center">
                            <div v-if="agent.category === 'TA'" class="col-12 col-md-4" v-for="agent in agents">
                                <div class="box-element bg-white box-shadow d-flex flex-column rounded">
                                    <div class="box-element-image">
                                        <a href="#" class="zoom-image rounded-top" @click="selectAgent(agent)" data-toggle="modal" data-target="#agentModal">
                                            <span class="zoom-image-hover"></span>
                                            <img class="width-100 rounded-top" v-if="agent.picture !== ''" :src="'/assets/agents/images/'+agent.picture" :alt="agent.name">
                                            <img class="width-100 rounded-top" v-else src="/assets/placeholders/agent-placeholder.jpg" :alt="agent.name">
                                        </a>
                                    </div>
                                    <div class="box-element-info">
                                        <div class="row">
                                            <div class="col-auto mr-auto">
                                                <h3 class="font-md margin-0">{{ agent.name }}</h3>
                                                <p>{{ agent.title }}</p>
                                                <p>305-830-0200 x <span><strong>{{ agent.extension }}</strong></span></p>
                                            </div>
                                            <div class="col-auto">
                                                <a :href="'mailto:'+agent.email" class="font-md link-style d-block"><i class="material-icons">mail</i></a>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="box-element-link text-center mt-auto">
                                        <a href="#" class="font-weight-bold font-md link-style" @click="selectAgent(agent)" data-toggle="modal" data-target="#agentModal">See full profile</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-bd" role="tabpanel" aria-labelledby="pills-bd-tab">
                        <div class="row justify-content-center">
                            <div v-if="agent.category === 'BD'" class="col-12 col-md-4" v-for="agent in agents">
                                <div class="box-element bg-white box-shadow d-flex flex-column rounded">
                                    <div class="box-element-image">
                                        <a href="#" class="zoom-image rounded-top" @click="selectAgent(agent)" data-toggle="modal" data-target="#agentModal">
                                            <span class="zoom-image-hover"></span>
                                            <img class="width-100 rounded-top" v-if="agent.picture !== ''" :src="'/assets/agents/images/'+agent.picture" :alt="agent.name">
                                            <img class="width-100 rounded-top" v-else src="/assets/placeholders/agent-placeholder.jpg" :alt="agent.name">
                                        </a>
                                    </div>
                                    <div class="box-element-info">
                                        <div class="row">
                                            <div class="col-auto mr-auto">
                                                <h3 class="font-md margin-0">{{ agent.name }}</h3>
                                                <p>{{ agent.title }}</p>
                                                <p>305-830-0200 x <span><strong>{{ agent.extension }}</strong></span></p>
                                            </div>
                                            <div class="col-auto">
                                                <a :href="'mailto:'+agent.email" class="font-md link-style d-block"><i class="material-icons">mail</i></a>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="box-element-link text-center mt-auto">
                                        <a href="#" class="font-weight-bold font-md link-style" @click="selectAgent(agent)" data-toggle="modal" data-target="#agentModal">See full profile</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-co" role="tabpanel" aria-labelledby="pills-co-tab">
                        <div class="row justify-content-center">
                            <div v-if="agent.category === 'CO'" class="col-12 col-md-4" v-for="agent in agents">
                                <div class="box-element bg-white box-shadow d-flex flex-column rounded">
                                    <div class="box-element-image">
                                        <a href="#" class="zoom-image rounded-top" @click="selectAgent(agent)" data-toggle="modal" data-target="#agentModal">
                                            <span class="zoom-image-hover"></span>
                                            <img class="width-100 rounded-top" v-if="agent.picture !== ''" :src="'/assets/agents/images/'+agent.picture" :alt="agent.name">
                                            <img class="width-100 rounded-top" v-else src="/assets/placeholders/agent-placeholder.jpg" :alt="agent.name">
                                        </a>
                                    </div>
                                    <div class="box-element-info">
                                        <div class="row">
                                            <div class="col-auto mr-auto">
                                                <h3 class="font-md margin-0">{{ agent.name }}</h3>
                                                <p>{{ agent.title }}</p>
                                                <p>305-830-0200 x <span><strong>{{ agent.extension }}</strong></span></p>
                                            </div>
                                            <div class="col-auto">
                                                <a :href="'mailto:'+agent.email" class="font-md link-style d-block"><i class="material-icons">mail</i></a>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="box-element-link text-center mt-auto">
                                        <a href="#" class="font-weight-bold font-md link-style" @click="selectAgent(agent)" data-toggle="modal" data-target="#agentModal">See full profile</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>

            </div>
        </section>

        <section-quotes-partners></section-quotes-partners>

        <!-- More About Us Section -->
        <!--<section class="section-style text-center">
            <div class="container"
                 data-aos="fade-right"
                 data-aos-offset="100"
                 data-aos-once="true"
                 data-aos-duration="500">
                <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md">More about UJV</h1>
                <section-more-ujv></section-more-ujv>
            </div>
        </section>-->

        <!-- UJV App Section -->
        <section class="section-style">
            <div class="container padding-right-left-0"
                 data-aos="fade-left"
                 data-aos-offset="100"
                 data-aos-once="true"
                 data-aos-duration="500">
                <div class="row">
                    <div class="col">
                        <section-app-small></section-app-small>
                    </div>
                </div>
            </div>
        </section>

        <!-- Testimonies Section -->
        <testimonies-container></testimonies-container>

        <!-- Seller of Travel Certification -->
        <section class="section-style">
            <div class="container padding-right-left-0"
                 data-aos="fade-left"
                 data-aos-offset="100"
                 data-aos-once="true"
                 data-aos-duration="500">
                <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">
                    UJV is registered
                </h2>
                <div class="row justify-content-sm-center">
                    <div class="col-12 col-md-5">
                        <p class="text-center">
                            "Ultimate Jet Vacations, LLC is registered with the State of Florida as a Seller of Travel. <strong>Registration No. ST39409</strong>"
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Agent Details Modal -->
        <div class="modal fade" id="agentModal" tabindex="-1" role="dialog" aria-labelledby="agentModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div v-if="selectedAgent" class="modal-content">
                    <div class="modal-header modal-header-gradient rounded-top">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="material-icons d-none d-md-inline-block">close</i>
                                <i class="material-icons d-md-none">arrow_back</i>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <img class="width-100 rounded-top" v-if="selectedAgent.picture !== ''" :src="'/assets/agents/images/'+selectedAgent.picture" :alt="selectedAgent.name">
                        <img class="width-100 rounded-top" v-else src="/assets/placeholders/agent-placeholder.jpg" :alt="selectedAgent.name">
                        <div class="modal-body-content">
                            <div class="row">
                                <div class="col-auto mr-auto">
                                    <h3 class="font-md margin-0">{{ selectedAgent.name }}</h3>
                                    <p>{{ selectedAgent.title }}</p>
                                    <p>305-830-0200 x <span><strong>{{ selectedAgent.extension }}</strong></span></p>
                                </div>
                                <div class="col-auto">
                                    <a :href="'mailto:'+selectedAgent.email" class="font-md link-style d-block"><i class="material-icons">mail</i></a>
                                </div>
                            </div>
                            <hr>
                            <p class="text-justify">{{ selectedAgent.testimonial }}</p>                          
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SectionAppSmall from '../components/sections/AppSmall'
    import SectionMoreUjv from '../components/sections/MoreUjv'
    import SectionQuotesPartners from '../components/sections/QuotesPartners'
    import NextSectionArrow from "./../components/misc/NextSectionArrow";
    import TestimoniesContainer from "../components/data-containers/TestimoniesContainer";

    export default {
        created() {
            this.fetchAgents();
        },

        components: { SectionAppSmall, SectionMoreUjv, SectionQuotesPartners, NextSectionArrow , TestimoniesContainer},

        computed: {
            showAgents() { return this.agents.length > 0 }
        },

        data() {
            return {
                selectedAgent: null,
                agents: [],
            }
        },

        methods: {
            async fetchAgents() {
                try {
                    let response = await axios.get("/assets/agents/data.json");
                    this.agents = response.data || [];
                } catch (ignore) {
                    this.agents = [];
                }
            },
            selectAgent(agent) {
                this.selectedAgent = agent;
            }
        }
    }
</script>

<style lang="scss">
    /** Unique Index Styles **/
    div.about-us-image {
        background: url(/assets/bg/about-us-2.jpg) no-repeat center center;
    }
</style>
